<mat-form-field [formGroup]="parentForm" [appearance]="appearance" [color]="color">
  <mat-label>{{label}}</mat-label>
  <input matInput
    formControlName="{{name}}" type="{{type}}" placeholder="{{placeholder}}" [readonly]="readonly" [maxLength]="maxLength"
    #input (blur)="blur(input.value)" (paste)="paste(input.value)" (keyup)="keyUp(input.value)">
  @if (!fieldValid) {
    <mat-error>{{errorMessage}}</mat-error>
  }
</mat-form-field>
